import React, { memo } from "react";
function Contact() {
    return (
  <React.Fragment>
       <main className="container-fluid p-0" >        
        <section className="contact-image-section">
            <div className="contact-image-container">
                <div className="contact-content-section">
                <h1 className="contact-main-title fw-l">Let's Get <br/> in Touch</h1>
                </div>
            </div>
        </section>
                
        <section className="contact-section" id="">                        
            <div className="contact-detail-container">
                <div className="address-section">
                    <div className="contact-title">
                        <h2 className="mb-4">Contact Information</h2>
                    </div>
                    <div className="contact-information">
                        <div className="info-1 mb-4">
                            <h3 className="mb-2 contact-subtitle">Corporate Office / Send any written disputes to</h3>
                            <p className="xxsmall text-balance"><i className="bx bx-map-pin"></i> Credence Resource Management, LLC 1111 Digital Drive, Suite 101, Richardson TX 750817</p>
                        </div>
                        <div className="info-2">
                            <h3 className="mb-2 contact-subtitle">Correspondence Address</h3>
                            <p className="xxsmall"><i className="bx bx-map-pin"></i> PO Box 2300 Southgate, MI 48195-4300</p>
                        </div>
                    </div>
                </div>
                <div className="consumer-section">
                   <div className="contact-title">
                        <h2 className="mb-4">Consumer Related Services</h2>
                    </div>
                    <div className="contact-information">
                        <div className="info-1 mb-4">
                            <h3 className="mb-2 contact-subtitle">Customer Care / Pay by Phone</h3>
                            <a className="xxsmall mb-2" href="tel:1-855-880-4791" aria-label="Call customer service"> <i className="bx bx-phone"></i>  +1-855-880-4791</a>
                            <a className="xxsmall mb-2" href="mailto:customerservice@credencerm.com" aria-label="Send email to customerservice"><i className="bx bx-envelope"></i> customerservice@credencerm.com</a>
                        </div>
                        <div className="info-2">
                            <h3 className="mb-2 contact-subtitle">Consumer Complaints / Disputes</h3>
                            <a className="xxsmall mb-2" href="tel:1-855-880-4792"> <i className="bx bx-phone"></i>  +1-855-880-4791</a>
                            <a className="xxsmall mb-2" href="mailto:complaints@credencerm.com"><i className="bx bx-envelope"></i> complaints@credencerm.com</a>
                            <a className="xxsmall mb-2" href="mailto:disputes@credencerm.com"><i className="bx bx-envelope"></i> disputes@credencerm.com</a>
                        </div>
                    </div>
                </div>
                <div className="corporate-section">
                    <div className="contact-title">
                        <h2 className="mb-4">Corporate Contact</h2>
                    </div>
                    <div className="contact-information">
                        <div className="info-1">
                            <h3 className="mb-2 contact-subtitle">Sales</h3>
                            <a className="xxsmall" href="mailto:sales@credencerm.com"><i className="bx bx-envelope"></i> sales@credencerm.com</a>
                        </div>
                        <div className="info-2">
                            <h3 className="mb-2 contact-subtitle">Employee Feedback</h3>
                            <a className="xxsmall" href="mailto:feedback@credencerm.com"><i className="bx bx-envelope"></i> feedback@credencerm.com</a>
                        </div>
                        <div className="info-3">
                            <h3 className="mb-2 contact-subtitle">Ex-Employee Verification Requests</h3>
                            <a className="xxsmall" href="mailto:employeeverification@credencerm.com"><i className="bx bx-envelope"></i> employeeverification@credencerm.com</a>
                        </div>
                    </div>
                </div>
            </div>

        </section>
               
    </main>
           
  </React.Fragment>
    );
  }
  
  export default Contact;
  